import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image/withIEPolyfill'
import React from 'react'

const NasdaqLogo = (props) => {
  const data = useStaticQuery(graphql`
    query {
      file(
        relativePath: {
          eq: "components/pages/HomePage/HomeHero/images/nasdaq-logo.png"
        }
      ) {
        childImageSharp {
          fixed(height: 50, width: 130, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)

  return <Img fixed={data.file.childImageSharp.fixed} alt="Nasdaq" {...props} />
}

export default NasdaqLogo
